import { useQuery } from "@tanstack/react-query";
import { AlertTriangle } from "lucide-react";

interface AiStatus {
  armed: boolean;
  yearMonth?: string | null;
  totalEur?: number | null;
  budgetEur?: number | null;
}

async function fetchAiStatus(): Promise<AiStatus> {
  const r = await fetch("/api/ai-status", { credentials: "same-origin" });
  if (!r.ok) {
    return { armed: false };
  }
  return (await r.json()) as AiStatus;
}

/**
 * Persistent top-of-app banner that surfaces the global AI kill-switch
 * to every signed-in user as long as it is armed. Polls /api/ai-status
 * every 60 s and re-checks on window focus so the banner disappears
 * within seconds of the admin releasing the kill-switch.
 */
export default function AiBudgetBanner() {
  const { data } = useQuery({
    queryKey: ["ai-status"],
    queryFn: fetchAiStatus,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
  });
  if (!data?.armed) return null;
  return (
    <div
      role="status"
      data-testid="ai-budget-banner"
      className="flex items-center gap-3 border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>
        Service IA en pause — le budget mensuel a été atteint. Les
        analyses, suggestions et conversations IA sont temporairement
        suspendues. Réessayez plus tard.
      </span>
    </div>
  );
}
